import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AnchorOrDivComponent } from '@rma/generic/ui/anchor-or-div';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-short-rating-summary',
  imports: [TranslocoModule, RmaIconComponent, AnchorOrDivComponent],
  templateUrl: './short-rating-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-row items-center',
  },
})
export class ShortRatingSummaryComponent {
  @Input()
  public rating = 5;

  @Input()
  public count: number | undefined;

  @Input()
  public reviewsRoute: string | undefined;

  @Input()
  public relativeTo?: ActivatedRoute | null = undefined;

  @Input()
  public showLinksToIndividualProfile: boolean | null = true;
}
